import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import { PlusIcon, MagnifyingGlassIcon, PencilIcon, TrashIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

export default function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  useEffect(() => { fetchTickets(); }, [search, page]);

  const fetchTickets = async () => {
    try {
      const response = await api.get('/tickets', { params: { search, page } });
      setTickets(response.data.data);
      setLastPage(response.data.last_page);
    } catch (error) {
      toast.error('Gabim');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Jeni i sigurt?')) return;
    try {
      await api.delete(`/tickets/${id}`);
      toast.success('U fshi!');
      fetchTickets();
    } catch (error) {
      toast.error('Gabim');
    }
  };

  const handleCheckin = async (id) => {
    try {
      await api.post(`/tickets/${id}/checkin`);
      toast.success('Check-in u krye!');
      fetchTickets();
    } catch (error) {
      toast.error('Gabim');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Biletat</h1>
        <Link to="/tickets/new" className="btn-primary flex items-center gap-2">
          <PlusIcon className="w-5 h-5" /> Shto Biletë
        </Link>
      </div>

      <div className="card">
        <div className="relative mb-4">
          <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input type="text" placeholder="Kërko me kod, pasagjer..." value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} className="input-field pl-10" />
        </div>

        {loading ? (
          <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-3 px-2 font-medium text-gray-500">Data</th>
                    <th className="text-left py-3 px-2 font-medium text-gray-500">Kodi</th>
                    <th className="text-left py-3 px-2 font-medium text-gray-500">Pasagjeri</th>
                    <th className="text-left py-3 px-2 font-medium text-gray-500">Klienti</th>
                    <th className="text-left py-3 px-2 font-medium text-gray-500">Destinacion</th>
                    <th className="text-right py-3 px-2 font-medium text-gray-500">Tarifa</th>
                    <th className="text-right py-3 px-2 font-medium text-gray-500">Fitim</th>
                    <th className="text-right py-3 px-2 font-medium text-gray-500">Total</th>
                    <th className="text-center py-3 px-2 font-medium text-gray-500">Veprime</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets.map((ticket) => (
                    <tr key={ticket.id} className="border-b hover:bg-gray-50">
                      <td className="py-3 px-2">{dayjs(ticket.ticket_date).format('DD/MM/YY')}</td>
                      <td className="py-3 px-2 font-medium">{ticket.ticket_code}</td>
                      <td className="py-3 px-2">{ticket.passenger_name}</td>
                      <td className="py-3 px-2 text-gray-500">{ticket.client?.name || ticket.client_name}</td>
                      <td className="py-3 px-2 text-gray-500">{ticket.destination?.name}</td>
                      <td className="py-3 px-2 text-right">€{ticket.fare}</td>
                      <td className="py-3 px-2 text-right text-green-600">€{ticket.tax}</td>
                      <td className="py-3 px-2 text-right font-medium">€{ticket.total}</td>
                      <td className="py-3 px-2 text-center">
                        {!ticket.checkin_done && (
                          <button onClick={() => handleCheckin(ticket.id)} className="p-1 text-gray-500 hover:text-green-600" title="Check-in">
                            <CheckCircleIcon className="w-5 h-5" />
                          </button>
                        )}
                        <Link to={`/tickets/${ticket.id}/edit`} className="p-1 text-gray-500 hover:text-primary-600 inline-block">
                          <PencilIcon className="w-5 h-5" />
                        </Link>
                        <button onClick={() => handleDelete(ticket.id)} className="p-1 text-gray-500 hover:text-red-600">
                          <TrashIcon className="w-5 h-5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {lastPage > 1 && (
              <div className="flex justify-center gap-2 mt-4">
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-secondary disabled:opacity-50">← Para</button>
                <span className="px-4 py-2">Faqja {page} / {lastPage}</span>
                <button onClick={() => setPage(p => Math.min(lastPage, p + 1))} disabled={page === lastPage} className="btn-secondary disabled:opacity-50">Pas →</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
